import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { SolutionType } from '../../../../shared/constants/user-info/solutionType';

type PromoCodesContextType = {
  solutionType: SolutionType;
  subscriptionTypeAvailable: boolean;
};

const PromoCodesContext = createContext<PromoCodesContextType | null>(null);

type PromoCodesContextProviderProps = PropsWithChildren & {
  solutionType: SolutionType;
  subscriptionTypeAvailable: boolean;
};

export const PromoCodesContextProvider = ({
  children,
  solutionType,
  subscriptionTypeAvailable,
}: PromoCodesContextProviderProps) => {
  const contextValue = useMemo(
    () => ({
      solutionType,
      subscriptionTypeAvailable,
    }),
    [solutionType, subscriptionTypeAvailable],
  );

  return <PromoCodesContext value={contextValue}>{children}</PromoCodesContext>;
};

export const usePromoCodesContext = () => {
  const context = useContext(PromoCodesContext);

  if (!context) {
    throw new Error('usePromoCodesContext must be used within a PromoCodesContext');
  }

  return context;
};
